// extracted by mini-css-extract-plugin
export default {"current":"index_current_wIfDq"};